import React, { useContext } from "react";
import { mapConfig } from "../../../constant";
import { Circle, GoogleMap, OverlayView } from "@react-google-maps/api";
import AppContext from "../../../AppContext";

const LocAnalytics = ({ data }) => {
  const { isLoaded } = useContext(AppContext);
  const handleApiLoaded = (map) => {
    // setMap(map);
    const bounds = new window.google.maps.LatLngBounds();
    data.map((marker) => {
      bounds.extend({
        lat: marker.center.lat,
        lng: marker.center.lng,
      });
    });
    map.fitBounds(bounds);
  };

  return (
    <>
      {isLoaded ? (
        <GoogleMap
          onLoad={handleApiLoaded}
          center={mapConfig.center}
          zoom={mapConfig.zoom}
          options={{
            styles: mapConfig.styles,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
          }}
          mapContainerStyle={{ height: "100%", width: "100%" }}
        >
          {data.map((x, key) => (
            <Circle
              key={key}
              center={x.center}
              radius={2600}
              options={{
                strokeColor: "#FF0000", // Color of the circle's outline
                strokeOpacity: 0.8, // Opacity of the circle's outline
                strokeWeight: 1, // Thickness of the circle's outline
                fillColor: "#FF0000", // Color of the circle's fill
                fillOpacity: 0.35, // Opacity of the circle's fil
              }}
            />
          ))}
          {data.map((x, key) => (
            <OverlayView
              position={x.center}
              key={key}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <div className="text-white">{x.duration}</div>
            </OverlayView>
          ))}
        </GoogleMap>
      ) : null}
    </>
  );
};

export default LocAnalytics;
